export const PATIENT_AUTH_FIELD_GROUP = 'CD2.PatientAuthFields';
export const PATIENT_AUTH_FIELD_DATE_OF_BIRTH = 'CD2.PatientAuthFields.DateOfBirth';
export const PATIENT_AUTH_FIELD_BIRTH_YEAR = 'CD2.PatientAuthFields.BirthYear';
export const PATIENT_AUTH_FIELD_ZIPCODE = 'CD2.PatientAuthFields.ZipCode';
